import { render, staticRenderFns } from "./MemberCompetencyDetail.vue?vue&type=template&id=c755b8ea&scoped=true"
import script from "./MemberCompetencyDetail.vue?vue&type=script&lang=js"
export * from "./MemberCompetencyDetail.vue?vue&type=script&lang=js"
import style0 from "./MemberCompetencyDetail.vue?vue&type=style&index=0&id=c755b8ea&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c755b8ea",
  null
  
)

export default component.exports